// frontend/src/app.tsx
import React from "react";
import AppRoutes from "./routes";
import LanguageGate from "./components/LanguageGate";

// AppRoutes renders the Router + layout + pages.
// LanguageGate ensures we don’t render any text until the correct language is known.
export default function App() {
  return (
    <LanguageGate>
      <AppRoutes />
    </LanguageGate>
  );
}

